<div class="row">
  <div class="col-8">
    <h3 style="text-align: right;">Mobile Number Verification</h3>
  </div>
  <div class="col" style="text-align: right;">
    <button mat-raised-button (click)="closeComponent()" style="color: white; background: red;">Skip</button>
  </div>
</div><br>
<div class="row" style="text-align: center;">
  <div class="col">
    <h1>Current Mobile Number is <b>{{mobile}}</b></h1>
  </div>
</div><br>
<div class="row" style="text-align: center;">
  <div class="col"><label>If this is Correct Number Please, <button mat-button class="button-class"
        (click)="confirmButtonClicked()">Confirm</button></label></div>

</div>
<div class="row">
  <div class="col" style="text-align: center;">
    <label style="font-size: 40px; color: orange;">Or</label>
  </div>
</div>
<div class="row">
  <div class="col-3"></div>
  <div class="col-6"><label> If not Enter Mobile number,&nbsp; </label> <input type='number' matInput
      style="font-size: 25px;font-weight: bold; color: black; border: 1px solid black; padding: 10px;"
      [(ngModel)]="entered_mobile_number" />&nbsp;
    <div class="col-3"></div>
  </div>
</div>
<div class="row" style="text-align: center;">
  <div class="col">
    <button mat-button class="button-class" [disabled]="entered_mobile_number == null"
      (click)="confirmWithNewNumberButtonClicked()">Update</button></div>
</div>
